// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/questionnaire.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { ValueSource_Source } from "./value_source";
import { CompletedAction } from "./actions";
import { Value } from "../../google/protobuf/struct";
import { RetirementMethod } from "./family";
import { PensionType } from "./person";
import { RRSPAccount_PlanType } from "./accounts";
import { AccountType } from "./accounts";
import { LoanType } from "./debts";
import { PropertyKind } from "./property";
import { Lender } from "./debts";
import { GroupRRSPPlan } from "./person";
import { IncomeKind } from "./person";
import { PriorityKind } from "./family";
import { Province } from "./address";
import { MaritalStatus } from "./family";
import { Date } from "./date";
// Answer sets (architecture-redesign.md item J §6). The client only ever builds these; the engine
// merges them into a Family (ApplyQuestionnaire, ApplyPlanRefresh), so one place interprets answers.
// Merged values get source USER. Anything not asked stays unknown for the defaults pass to fill.
// 
// The client mints uuids for every new entity (members, accounts, debts, ...), so answers can refer
// to each other (e.g. an account's owner) before anything is saved.

/**
 * A questionnaire, or part of one. Each section that is set replaces that part of the base family:
 * entities of the section's kinds that aren't listed are removed, listed ones are created or updated
 * by uuid. Unset sections leave the base unchanged. Onboarding sends every section; Update Data,
 * Sharpen and the Decisions tools send only what they change.
 *
 * @generated from protobuf message core.v1.Questionnaire
 */
export interface Questionnaire {
    /**
     * @generated from protobuf field: int32 version = 1;
     */
    version: number; // QUESTIONNAIRE_VERSION, currently 1
    /**
     * @generated from protobuf field: core.v1.HouseholdSection household = 2;
     */
    household?: HouseholdSection;
    /**
     * @generated from protobuf field: core.v1.PrioritiesSection priorities = 3;
     */
    priorities?: PrioritiesSection;
    /**
     * @generated from protobuf field: core.v1.IncomeSection income = 4;
     */
    income?: IncomeSection;
    /**
     * @generated from protobuf field: core.v1.PropertiesSection properties = 5;
     */
    properties?: PropertiesSection;
    /**
     * @generated from protobuf field: core.v1.DebtsSection debts = 6;
     */
    debts?: DebtsSection;
    /**
     * @generated from protobuf field: core.v1.AccountsSection accounts = 7;
     */
    accounts?: AccountsSection;
    /**
     * @generated from protobuf field: core.v1.SpendingSection spending = 8;
     */
    spending?: SpendingSection;
    /**
     * @generated from protobuf field: core.v1.SafetyNetSection safety_net = 9;
     */
    safetyNet?: SafetyNetSection;
    /**
     * @generated from protobuf field: core.v1.RetirementSection retirement = 10;
     */
    retirement?: RetirementSection;
    /**
     * Single-field edits (Update Data, Sharpen), by field path (see ValueSource). Applied after the
     * sections. The engine validates each path and value.
     *
     * @generated from protobuf field: repeated core.v1.FieldEdit field_edits = 11;
     */
    fieldEdits: FieldEdit[];
    /**
     * Answers to "we estimated X" and "our estimate changed" prompts.
     *
     * @generated from protobuf field: repeated core.v1.DefaultDecision default_decisions = 12;
     */
    defaultDecisions: DefaultDecision[];
    /**
     * Facts are as of this date (normally today). Becomes Family.facts_as_of when later than it.
     *
     * @generated from protobuf field: core.v1.Date as_of = 13;
     */
    asOf?: Date;
}
/**
 * @generated from protobuf message core.v1.HouseholdSection
 */
export interface HouseholdSection {
    /**
     * @generated from protobuf field: repeated core.v1.HouseholdSection.Member members = 1;
     */
    members: HouseholdSection_Member[];
    /**
     * @generated from protobuf field: core.v1.MaritalStatus marital_status = 2;
     */
    maritalStatus: MaritalStatus;
    /**
     * @generated from protobuf field: repeated core.v1.HouseholdSection.Child children = 3;
     */
    children: HouseholdSection_Child[];
    /**
     * @generated from protobuf field: core.v1.Province province = 4;
     */
    province: Province;
}
/**
 * @generated from protobuf message core.v1.HouseholdSection.Member
 */
export interface HouseholdSection_Member {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.HouseholdSection.Member.Role role = 2;
     */
    role: HouseholdSection_Member_Role;
    /**
     * @generated from protobuf field: string given_name = 3;
     */
    givenName: string;
    /**
     * @generated from protobuf field: string family_name = 4;
     */
    familyName: string;
    /**
     * @generated from protobuf field: core.v1.Date dob = 5;
     */
    dob?: Date;
}
/**
 * @generated from protobuf enum core.v1.HouseholdSection.Member.Role
 */
export enum HouseholdSection_Member_Role {
    /**
     * @generated from protobuf enum value: ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ROLE_SELF = 1;
     */
    SELF = 1,
    /**
     * @generated from protobuf enum value: ROLE_PARTNER = 2;
     */
    PARTNER = 2
}
/**
 * @generated from protobuf message core.v1.HouseholdSection.Child
 */
export interface HouseholdSection_Child {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string given_name = 2;
     */
    givenName: string;
    /**
     * @generated from protobuf field: string family_name = 3;
     */
    familyName: string;
    /**
     * @generated from protobuf field: core.v1.Date dob = 4;
     */
    dob?: Date;
}
/**
 * @generated from protobuf message core.v1.PrioritiesSection
 */
export interface PrioritiesSection {
    /**
     * @generated from protobuf field: repeated core.v1.PrioritiesSection.Priority priorities = 1;
     */
    priorities: PrioritiesSection_Priority[];
    /**
     * @generated from protobuf field: int32 retirement_importance = 2;
     */
    retirementImportance: number; // "Retiring comfortably"; 0 = keep the current value
}
/**
 * @generated from protobuf message core.v1.PrioritiesSection.Priority
 */
export interface PrioritiesSection_Priority {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.PriorityKind kind = 2;
     */
    kind: PriorityKind;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double cost = 4;
     */
    cost?: number; // unset = "not sure"
    /**
     * @generated from protobuf field: core.v1.Date when = 5;
     */
    when?: Date; // day 0 = month only; month 0 = year only
    /**
     * @generated from protobuf field: int32 importance = 6;
     */
    importance: number; // 1-10
    /**
     * @generated from protobuf field: bool repeats = 7;
     */
    repeats: boolean;
    /**
     * @generated from protobuf field: core.v1.PrioritiesSection.Frequency frequency = 8;
     */
    frequency: PrioritiesSection_Frequency;
    /**
     * @generated from protobuf field: core.v1.Date until = 9;
     */
    until?: Date;
    /**
     * @generated from protobuf field: repeated string beneficiary_uuids = 10;
     */
    beneficiaryUuids: string[];
    /**
     * BUY_HOME only: the home's price. A BUY_HOME answer becomes a HomebuyingPriority (never a
     * FinancialPriority): `cost` is its down payment (unset = 20% of the price), `when` its due date.
     *
     * @generated from protobuf field: optional double house_price = 11;
     */
    housePrice?: number;
}
/**
 * @generated from protobuf enum core.v1.PrioritiesSection.Frequency
 */
export enum PrioritiesSection_Frequency {
    /**
     * @generated from protobuf enum value: FREQUENCY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FREQUENCY_MONTHLY = 1;
     */
    MONTHLY = 1,
    /**
     * @generated from protobuf enum value: FREQUENCY_YEARLY = 2;
     */
    YEARLY = 2,
    /**
     * @generated from protobuf enum value: FREQUENCY_EVERY_2_YEARS = 3;
     */
    EVERY_2_YEARS = 3,
    /**
     * @generated from protobuf enum value: FREQUENCY_EVERY_3_YEARS = 4;
     */
    EVERY_3_YEARS = 4,
    /**
     * @generated from protobuf enum value: FREQUENCY_EVERY_5_YEARS = 5;
     */
    EVERY_5_YEARS = 5
}
/**
 * @generated from protobuf message core.v1.IncomeSection
 */
export interface IncomeSection {
    /**
     * @generated from protobuf field: repeated core.v1.IncomeSection.Income incomes = 1;
     */
    incomes: IncomeSection_Income[];
}
/**
 * @generated from protobuf message core.v1.IncomeSection.Income
 */
export interface IncomeSection_Income {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string member_uuid = 2;
     */
    memberUuid: string;
    /**
     * @generated from protobuf field: core.v1.IncomeKind kind = 3;
     */
    kind: IncomeKind;
    /**
     * @generated from protobuf field: double annual_amount_before_tax = 4;
     */
    annualAmountBeforeTax: number;
    /**
     * @generated from protobuf field: string occupation = 5;
     */
    occupation: string;
    /**
     * @generated from protobuf field: core.v1.Date start_date = 6;
     */
    startDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date end_date = 7;
     */
    endDate?: Date;
    /**
     * @generated from protobuf field: optional core.v1.GroupRRSPPlan group_rrsp_plan = 8;
     */
    groupRrspPlan?: GroupRRSPPlan; // jobs only; unset = no employer match
    /**
     * @generated from protobuf field: string name = 9;
     */
    name: string; // what the household calls it ("Day job", "The rental"): Job.title, UntaxedIncome.name
}
/**
 * @generated from protobuf message core.v1.PropertiesSection
 */
export interface PropertiesSection {
    /**
     * @generated from protobuf field: repeated core.v1.PropertiesSection.PropertyAnswer properties = 1;
     */
    properties: PropertiesSection_PropertyAnswer[];
}
/**
 * @generated from protobuf message core.v1.PropertiesSection.MortgageAnswer
 */
export interface PropertiesSection_MortgageAnswer {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: double balance = 2;
     */
    balance: number;
    /**
     * @generated from protobuf field: optional double interest_rate = 3;
     */
    interestRate?: number; // percent; unset = not known (the engine estimates it)
    /**
     * @generated from protobuf field: optional int32 remaining_years = 4;
     */
    remainingYears?: number;
    /**
     * @generated from protobuf field: optional double monthly_payment = 5;
     */
    monthlyPayment?: number;
    /**
     * @generated from protobuf field: core.v1.Lender lender = 6;
     */
    lender: Lender;
    /**
     * "Year you took it out" and "How many years it was for" (both or neither): the Mortgage's
     * purchase_date (1 January of that year) and amortization_period. Take precedence over
     * remaining_years and monthly_payment. Neither set: the stored terms are kept.
     *
     * @generated from protobuf field: optional int32 start_year = 7;
     */
    startYear?: number;
    /**
     * @generated from protobuf field: optional int32 term_years = 8;
     */
    termYears?: number;
}
/**
 * @generated from protobuf message core.v1.PropertiesSection.PropertyAnswer
 */
export interface PropertiesSection_PropertyAnswer {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.PropertyKind kind = 2;
     */
    kind: PropertyKind;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 4;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: core.v1.PropertiesSection.MortgageAnswer mortgage = 5;
     */
    mortgage?: PropertiesSection_MortgageAnswer; // unset = owned outright
    /**
     * @generated from protobuf field: optional double annual_property_tax = 6;
     */
    annualPropertyTax?: number;
}
/**
 * @generated from protobuf message core.v1.DebtsSection
 */
export interface DebtsSection {
    /**
     * @generated from protobuf field: repeated core.v1.DebtsSection.Debt debts = 1;
     */
    debts: DebtsSection_Debt[];
}
/**
 * @generated from protobuf message core.v1.DebtsSection.Debt
 */
export interface DebtsSection_Debt {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.LoanType kind = 2;
     */
    kind: LoanType; // LOAN_TYPE_CREDIT_CARD becomes a CreditCard
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string member_uuid = 4;
     */
    memberUuid: string; // whose debt; empty = the first member
    /**
     * @generated from protobuf field: double balance = 5;
     */
    balance: number;
    /**
     * @generated from protobuf field: optional double interest_rate = 6;
     */
    interestRate?: number; // percent; unset = not known (the engine estimates it)
    /**
     * @generated from protobuf field: optional double monthly_payment = 7;
     */
    monthlyPayment?: number;
    /**
     * @generated from protobuf field: optional double credit_limit = 8;
     */
    creditLimit?: number;
}
/**
 * @generated from protobuf message core.v1.AccountsSection
 */
export interface AccountsSection {
    /**
     * @generated from protobuf field: repeated core.v1.AccountsSection.Account accounts = 1;
     */
    accounts: AccountsSection_Account[];
}
/**
 * @generated from protobuf message core.v1.AccountsSection.Account
 */
export interface AccountsSection_Account {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.AccountType kind = 2;
     */
    kind: AccountType; // CHEQUING covers chequing and savings (see savings)
    /**
     * @generated from protobuf field: bool savings = 3;
     */
    savings: boolean;
    /**
     * @generated from protobuf field: string name = 4;
     */
    name: string;
    /**
     * @generated from protobuf field: string member_uuid = 5;
     */
    memberUuid: string; // owner
    /**
     * @generated from protobuf field: double balance = 6;
     */
    balance: number;
    /**
     * @generated from protobuf field: repeated string beneficiary_uuids = 7;
     */
    beneficiaryUuids: string[]; // RESP
    /**
     * @generated from protobuf field: optional double interest_rate = 8;
     */
    interestRate?: number; // chequing and savings
    /**
     * @generated from protobuf field: core.v1.RRSPAccount.PlanType plan_type = 9;
     */
    planType: RRSPAccount_PlanType; // RRSP: personal or group (through work); unspecified keeps it
}
/**
 * @generated from protobuf message core.v1.SpendingSection
 */
export interface SpendingSection {
    /**
     * @generated from protobuf field: double essential_monthly = 1;
     */
    essentialMonthly: number; // groceries, utilities, insurance, transport, childcare, ...
    /**
     * @generated from protobuf field: double lifestyle_monthly = 2;
     */
    lifestyleMonthly: number; // eating out, travel, subscriptions, ...
    /**
     * @generated from protobuf field: optional double rent_monthly = 3;
     */
    rentMonthly?: number;
}
/**
 * @generated from protobuf message core.v1.SafetyNetSection
 */
export interface SafetyNetSection {
    /**
     * @generated from protobuf field: repeated core.v1.SafetyNetSection.EmergencyFund emergency_funds = 1;
     */
    emergencyFunds: SafetyNetSection_EmergencyFund[]; // empty = "none of it"
    /**
     * @generated from protobuf field: repeated core.v1.SafetyNetSection.PensionAnswer pensions = 2;
     */
    pensions: SafetyNetSection_PensionAnswer[];
}
/**
 * @generated from protobuf message core.v1.SafetyNetSection.EmergencyFund
 */
export interface SafetyNetSection_EmergencyFund {
    /**
     * @generated from protobuf field: string account_uuid = 1;
     */
    accountUuid: string;
    /**
     * @generated from protobuf field: bool whole_balance = 2;
     */
    wholeBalance: boolean;
    /**
     * @generated from protobuf field: optional double amount = 3;
     */
    amount?: number;
}
/**
 * @generated from protobuf message core.v1.SafetyNetSection.PensionAnswer
 */
export interface SafetyNetSection_PensionAnswer {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string member_uuid = 2;
     */
    memberUuid: string;
    /**
     * @generated from protobuf field: core.v1.PensionType type = 3;
     */
    type: PensionType; // NO_PENSION removes the member's pensions
    /**
     * @generated from protobuf field: string job_uuid = 4;
     */
    jobUuid: string; // the job that provides it, if known
}
/**
 * @generated from protobuf message core.v1.RetirementSection
 */
export interface RetirementSection {
    /**
     * @generated from protobuf field: core.v1.RetirementMethod method = 1;
     */
    method: RetirementMethod;
    /**
     * @generated from protobuf field: optional double income_replacement_percent = 2;
     */
    incomeReplacementPercent?: number;
    /**
     * @generated from protobuf field: optional int32 retirement_age = 3;
     */
    retirementAge?: number; // applies to every member when set
}
/**
 * A path may end at a whole list item at any level (e.g. "expenses[<uuid>]",
 * "persons[<uuid>].jobs[<uuid>]"); its value is the item as a proto3-JSON object: the item is created
 * when the key is new, replaced when it exists, and removed when the value is null.
 *
 * @generated from protobuf message core.v1.FieldEdit
 */
export interface FieldEdit {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: google.protobuf.Value value = 2;
     */
    value?: Value; // proto3-JSON value for the field; null clears it (back to unknown)
}
/**
 * @generated from protobuf message core.v1.DefaultDecision
 */
export interface DefaultDecision {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: core.v1.DefaultDecision.Decision decision = 2;
     */
    decision: DefaultDecision_Decision;
}
/**
 * @generated from protobuf enum core.v1.DefaultDecision.Decision
 */
export enum DefaultDecision_Decision {
    /**
     * @generated from protobuf enum value: DECISION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * keep the current default as the user's value (source CONFIRMED)
     *
     * @generated from protobuf enum value: DECISION_CONFIRM = 1;
     */
    CONFIRM = 1,
    /**
     * a default changed; keep the confirmed value, remember the declined default
     *
     * @generated from protobuf enum value: DECISION_KEEP_MINE = 2;
     */
    KEEP_MINE = 2,
    /**
     * a default changed; take the new default (source CONFIRMED)
     *
     * @generated from protobuf enum value: DECISION_TAKE_NEW = 3;
     */
    TAKE_NEW = 3
}
/**
 * The check-in (plan refresh). The engine rolls the family forward from facts_as_of to as_of,
 * applying what the household actually did, then applies the verified balances.
 *
 * @generated from protobuf message core.v1.PlanRefreshAnswers
 */
export interface PlanRefreshAnswers {
    /**
     * @generated from protobuf field: core.v1.Date as_of = 1;
     */
    asOf?: Date; // becomes Family.facts_as_of
    /**
     * Recommended actions with what actually happened. A recommended action with no user_submitted
     * action was not done.
     *
     * @generated from protobuf field: repeated core.v1.CompletedAction completed_actions = 2;
     */
    completedActions: CompletedAction[];
    /**
     * @generated from protobuf field: repeated core.v1.FieldEdit verified_balances = 3;
     */
    verifiedBalances: FieldEdit[];
    /**
     * Balances read from a connected institution since the last check-in. Applied after the roll-forward
     * and before verified_balances, so a figure the user enters wins.
     *
     * @generated from protobuf field: repeated core.v1.ImportedBalances imported = 4;
     */
    imported: ImportedBalances[];
}
/**
 * Balances from one connection (e.g. one Flinks login), all true on as_of.
 *
 * @generated from protobuf message core.v1.ImportedBalances
 */
export interface ImportedBalances {
    /**
     * @generated from protobuf field: core.v1.ValueSource.Source source = 1;
     */
    source: ValueSource_Source; // SOURCE_CSV, SOURCE_FLINKS or SOURCE_WEALTHICA
    /**
     * @generated from protobuf field: core.v1.Date as_of = 2;
     */
    asOf?: Date; // on or after Family.facts_as_of, and on or before PlanRefreshAnswers.as_of
    /**
     * @generated from protobuf field: repeated core.v1.FieldEdit balances = 3;
     */
    balances: FieldEdit[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Questionnaire$Type extends MessageType<Questionnaire> {
    constructor() {
        super("core.v1.Questionnaire", [
            { no: 1, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "household", kind: "message", T: () => HouseholdSection },
            { no: 3, name: "priorities", kind: "message", T: () => PrioritiesSection },
            { no: 4, name: "income", kind: "message", T: () => IncomeSection },
            { no: 5, name: "properties", kind: "message", T: () => PropertiesSection },
            { no: 6, name: "debts", kind: "message", T: () => DebtsSection },
            { no: 7, name: "accounts", kind: "message", T: () => AccountsSection },
            { no: 8, name: "spending", kind: "message", T: () => SpendingSection },
            { no: 9, name: "safety_net", kind: "message", T: () => SafetyNetSection },
            { no: 10, name: "retirement", kind: "message", T: () => RetirementSection },
            { no: 11, name: "field_edits", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FieldEdit },
            { no: 12, name: "default_decisions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DefaultDecision },
            { no: 13, name: "as_of", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Questionnaire
 */
export const Questionnaire = new Questionnaire$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HouseholdSection$Type extends MessageType<HouseholdSection> {
    constructor() {
        super("core.v1.HouseholdSection", [
            { no: 1, name: "members", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => HouseholdSection_Member },
            { no: 2, name: "marital_status", kind: "enum", T: () => ["core.v1.MaritalStatus", MaritalStatus, "MARITAL_STATUS_"] },
            { no: 3, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => HouseholdSection_Child },
            { no: 4, name: "province", kind: "enum", T: () => ["core.v1.Province", Province, "PROVINCE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.HouseholdSection
 */
export const HouseholdSection = new HouseholdSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HouseholdSection_Member$Type extends MessageType<HouseholdSection_Member> {
    constructor() {
        super("core.v1.HouseholdSection.Member", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "role", kind: "enum", T: () => ["core.v1.HouseholdSection.Member.Role", HouseholdSection_Member_Role, "ROLE_"] },
            { no: 3, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dob", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.HouseholdSection.Member
 */
export const HouseholdSection_Member = new HouseholdSection_Member$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HouseholdSection_Child$Type extends MessageType<HouseholdSection_Child> {
    constructor() {
        super("core.v1.HouseholdSection.Child", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dob", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.HouseholdSection.Child
 */
export const HouseholdSection_Child = new HouseholdSection_Child$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrioritiesSection$Type extends MessageType<PrioritiesSection> {
    constructor() {
        super("core.v1.PrioritiesSection", [
            { no: 1, name: "priorities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PrioritiesSection_Priority },
            { no: 2, name: "retirement_importance", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PrioritiesSection
 */
export const PrioritiesSection = new PrioritiesSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrioritiesSection_Priority$Type extends MessageType<PrioritiesSection_Priority> {
    constructor() {
        super("core.v1.PrioritiesSection.Priority", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.PriorityKind", PriorityKind, "PRIORITY_KIND_"] },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cost", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "when", kind: "message", T: () => Date },
            { no: 6, name: "importance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "repeats", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "frequency", kind: "enum", T: () => ["core.v1.PrioritiesSection.Frequency", PrioritiesSection_Frequency, "FREQUENCY_"] },
            { no: 9, name: "until", kind: "message", T: () => Date },
            { no: 10, name: "beneficiary_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "house_price", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PrioritiesSection.Priority
 */
export const PrioritiesSection_Priority = new PrioritiesSection_Priority$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncomeSection$Type extends MessageType<IncomeSection> {
    constructor() {
        super("core.v1.IncomeSection", [
            { no: 1, name: "incomes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IncomeSection_Income }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.IncomeSection
 */
export const IncomeSection = new IncomeSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncomeSection_Income$Type extends MessageType<IncomeSection_Income> {
    constructor() {
        super("core.v1.IncomeSection.Income", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "kind", kind: "enum", T: () => ["core.v1.IncomeKind", IncomeKind, "INCOME_KIND_"] },
            { no: 4, name: "annual_amount_before_tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "occupation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "start_date", kind: "message", T: () => Date },
            { no: 7, name: "end_date", kind: "message", T: () => Date },
            { no: 8, name: "group_rrsp_plan", kind: "message", T: () => GroupRRSPPlan },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.IncomeSection.Income
 */
export const IncomeSection_Income = new IncomeSection_Income$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PropertiesSection$Type extends MessageType<PropertiesSection> {
    constructor() {
        super("core.v1.PropertiesSection", [
            { no: 1, name: "properties", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PropertiesSection_PropertyAnswer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PropertiesSection
 */
export const PropertiesSection = new PropertiesSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PropertiesSection_MortgageAnswer$Type extends MessageType<PropertiesSection_MortgageAnswer> {
    constructor() {
        super("core.v1.PropertiesSection.MortgageAnswer", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "interest_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "remaining_years", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "monthly_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "lender", kind: "enum", T: () => ["core.v1.Lender", Lender, "LENDER_"] },
            { no: 7, name: "start_year", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "term_years", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PropertiesSection.MortgageAnswer
 */
export const PropertiesSection_MortgageAnswer = new PropertiesSection_MortgageAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PropertiesSection_PropertyAnswer$Type extends MessageType<PropertiesSection_PropertyAnswer> {
    constructor() {
        super("core.v1.PropertiesSection.PropertyAnswer", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.PropertyKind", PropertyKind, "PROPERTY_KIND_"] },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "mortgage", kind: "message", T: () => PropertiesSection_MortgageAnswer },
            { no: 6, name: "annual_property_tax", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PropertiesSection.PropertyAnswer
 */
export const PropertiesSection_PropertyAnswer = new PropertiesSection_PropertyAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DebtsSection$Type extends MessageType<DebtsSection> {
    constructor() {
        super("core.v1.DebtsSection", [
            { no: 1, name: "debts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DebtsSection_Debt }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DebtsSection
 */
export const DebtsSection = new DebtsSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DebtsSection_Debt$Type extends MessageType<DebtsSection_Debt> {
    constructor() {
        super("core.v1.DebtsSection.Debt", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.LoanType", LoanType, "LOAN_TYPE_"] },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "interest_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "monthly_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "credit_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DebtsSection.Debt
 */
export const DebtsSection_Debt = new DebtsSection_Debt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsSection$Type extends MessageType<AccountsSection> {
    constructor() {
        super("core.v1.AccountsSection", [
            { no: 1, name: "accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AccountsSection_Account }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.AccountsSection
 */
export const AccountsSection = new AccountsSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsSection_Account$Type extends MessageType<AccountsSection_Account> {
    constructor() {
        super("core.v1.AccountsSection.Account", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.AccountType", AccountType, "ACCOUNT_TYPE_"] },
            { no: 3, name: "savings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "beneficiary_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "interest_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "plan_type", kind: "enum", T: () => ["core.v1.RRSPAccount.PlanType", RRSPAccount_PlanType, "PLAN_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.AccountsSection.Account
 */
export const AccountsSection_Account = new AccountsSection_Account$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpendingSection$Type extends MessageType<SpendingSection> {
    constructor() {
        super("core.v1.SpendingSection", [
            { no: 1, name: "essential_monthly", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "lifestyle_monthly", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "rent_monthly", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.SpendingSection
 */
export const SpendingSection = new SpendingSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SafetyNetSection$Type extends MessageType<SafetyNetSection> {
    constructor() {
        super("core.v1.SafetyNetSection", [
            { no: 1, name: "emergency_funds", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SafetyNetSection_EmergencyFund },
            { no: 2, name: "pensions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SafetyNetSection_PensionAnswer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.SafetyNetSection
 */
export const SafetyNetSection = new SafetyNetSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SafetyNetSection_EmergencyFund$Type extends MessageType<SafetyNetSection_EmergencyFund> {
    constructor() {
        super("core.v1.SafetyNetSection.EmergencyFund", [
            { no: 1, name: "account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "whole_balance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "amount", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.SafetyNetSection.EmergencyFund
 */
export const SafetyNetSection_EmergencyFund = new SafetyNetSection_EmergencyFund$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SafetyNetSection_PensionAnswer$Type extends MessageType<SafetyNetSection_PensionAnswer> {
    constructor() {
        super("core.v1.SafetyNetSection.PensionAnswer", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["core.v1.PensionType", PensionType, "PENSION_TYPE_"] },
            { no: 4, name: "job_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.SafetyNetSection.PensionAnswer
 */
export const SafetyNetSection_PensionAnswer = new SafetyNetSection_PensionAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetirementSection$Type extends MessageType<RetirementSection> {
    constructor() {
        super("core.v1.RetirementSection", [
            { no: 1, name: "method", kind: "enum", T: () => ["core.v1.RetirementMethod", RetirementMethod, "RETIREMENT_METHOD_"] },
            { no: 2, name: "income_replacement_percent", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "retirement_age", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RetirementSection
 */
export const RetirementSection = new RetirementSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldEdit$Type extends MessageType<FieldEdit> {
    constructor() {
        super("core.v1.FieldEdit", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "message", T: () => Value }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.FieldEdit
 */
export const FieldEdit = new FieldEdit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefaultDecision$Type extends MessageType<DefaultDecision> {
    constructor() {
        super("core.v1.DefaultDecision", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "decision", kind: "enum", T: () => ["core.v1.DefaultDecision.Decision", DefaultDecision_Decision, "DECISION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DefaultDecision
 */
export const DefaultDecision = new DefaultDecision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanRefreshAnswers$Type extends MessageType<PlanRefreshAnswers> {
    constructor() {
        super("core.v1.PlanRefreshAnswers", [
            { no: 1, name: "as_of", kind: "message", T: () => Date },
            { no: 2, name: "completed_actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CompletedAction },
            { no: 3, name: "verified_balances", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FieldEdit },
            { no: 4, name: "imported", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImportedBalances }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PlanRefreshAnswers
 */
export const PlanRefreshAnswers = new PlanRefreshAnswers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportedBalances$Type extends MessageType<ImportedBalances> {
    constructor() {
        super("core.v1.ImportedBalances", [
            { no: 1, name: "source", kind: "enum", T: () => ["core.v1.ValueSource.Source", ValueSource_Source, "SOURCE_"] },
            { no: 2, name: "as_of", kind: "message", T: () => Date },
            { no: 3, name: "balances", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FieldEdit }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ImportedBalances
 */
export const ImportedBalances = new ImportedBalances$Type();
